module.exports = __webpack_public_path__ + "static/img-mob-dev-75cc1e65200fe02c883061dfab2a2da1.jpg";